import { PROXY_IMAGE_SUCCESS } from './constants';

let diplomaFoneState = {
    img_buff: '',
    logo_buff: ''
};
/**
 *
 * @param state
 * @param action
 * @returns {{img_buff: string, logo_buff: string}}
 */
const diplomaFone = ( state = diplomaFoneState, action ) => {
    switch ( action.type ) {
        case PROXY_IMAGE_SUCCESS : {
            return action.result.error ? diplomaFoneState : { ...action.result };
        }
        default:
            return state;
    }
};

export { diplomaFone };